import React from 'react'

import {
  toHHMMSS,
  platformTransitionStyle,
} from '../../../../../../shared/helpers.js'
import { useVideoPlayerData } from '../../VideoPlayerContext'

import type { TooltipProps } from './types'

export function Tooltip({ controlsPosition, seekLevel }: TooltipProps) {
  const { playerState } = useVideoPlayerData()
  return (
    <div
      id="tooltip"
      style={{
        backgroundColor: '#2F3437',
        transition: platformTransitionStyle('all 200ms linear'),
      }}
    >
      <span id="playhead-position">{toHHMMSS(controlsPosition)}</span>
      <div
        id="state-icons"
        className={`seek-speed-${Math.abs(seekLevel)} seeking-${
          seekLevel !== 0 && playerState.status === 'seeking'
        } rewinding-${seekLevel < 0 && playerState.status === 'seeking'}`}
      >
        <div className={'seek-icon seek-icon-1'} />
        <div className={'seek-icon seek-icon-2'} />
        <div className={'seek-icon seek-icon-3'} />
        <div id="playpause">
          {playerState.status === 'playing' ||
          playerState.status === 'adPlaying' ? (
            <div className="play-icon" />
          ) : (
            <div className="pause-icon" />
          )}
        </div>
      </div>
      <i />
    </div>
  )
}
